import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { isType } from '@sorare/core/src/lib/gql';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { Performance } from '@sorare/gameplay/src/components/player/Performance';

import type {
  FootballPlayerPerformanceQuery,
  FootballPlayerPerformanceQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const FOOTBALL_PLAYER_PERFORMANCE_QUERY = gql`
  query FootballPlayerPerformanceQuery($slug: String!) {
    anyPlayer(slug: $slug) {
      slug
      ...Performance_anyPlayer
    }
  }
  ${Performance.fragments.anyPlayer}
` as TypedDocumentNode<
  FootballPlayerPerformanceQuery,
  FootballPlayerPerformanceQueryVariables
>;

const StyledFullWidthContainer = styled(FullWidthContainer)`
  padding-top: var(--double-unit);
`;

export const loader = queryLoader(
  FOOTBALL_PLAYER_PERFORMANCE_QUERY,
  ({ slug }: PageParams) => ({ slug })
);

const PlayersSlugPage = () => {
  const { data } = useQueryLoader<FootballPlayerPerformanceQuery>();

  if (!data) return null;

  const player = data.anyPlayer;
  if (!isType(player, 'Player')) return null;

  return (
    <StyledFullWidthContainer>
      <Performance player={player} />
    </StyledFullWidthContainer>
  );
};

export default PlayersSlugPage;
